// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__Ci7hh","para-heading":"title_para-heading___z6VH"};